import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth } from '../../../../constants/actions'
import withUrlParams from '../../../../hoc/withUrlParams'
import ResetPassword from './component'

export const mapStateToProps = state => ({
  eventLogo: get(state, 'formSettings.eventLogo'),
  landingPageLogo: get(state, 'formSettings.landingPageLogo'),
  formType: get(state, 'formSettings.formType'),
  isSubmitPending: get(state, 'common.showLoadingIndicator'),
  orgLogo: get(state, 'formSettings.orgLogo'),
  resetPasswordMsg: get(state, 'auth.resetPasswordMsg.message'),
  resetStatus: get(state, 'auth.resetPasswordMsg.type'),
  landingPageImage: get(state, 'formSettings.landingPageImage'),
  bgGradientPrimaryColor: get(state, 'formSettings.bgGradientPrimaryColor'),
  bgGradientSecondaryColor: get(state, 'formSettings.bgGradientSecondaryColor'),
})

export default connect(mapStateToProps, {
  resetPassword: auth.resetPassword,
  setResetPasswordMsg: auth.setResetPasswordMsg,
})(withUrlParams(ResetPassword))
